import React from "react";

const Alert = ({
  type = "error",
  message = "Error",
  description,
  className = "",
  children,
  onClick,
}) => {
  return (
    <div className={`alert d-flex ${type} mb-1 ${className}`} onClick={onClick}>
      <div className="icon d-flex justify-content-center align-self-center">
        <div className="icon-ellipse align-self-center" />
      </div>
      <div className="align-self-center">
        <h3>{message}</h3>
        {description && <p>{description}</p>}

        {children}
      </div>
    </div>
  );
};

export default Alert;
